import { FC, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { TFunction } from 'i18next';

import { Country } from '../../Country';

const COUNTRY_FIELD_KEYS = [
  'country',
  'assignedCountry',
  'countryOfOrigin',
  'selectedCountry',
  'citizenship',
  'countryOfBirth',
];

const getIsCountryField = (key: string) => COUNTRY_FIELD_KEYS.includes(key);

type GetLabelProps = Pick<SelectFromListFieldViewProps, 'formFieldSelectItems' | 'value'> & {
  t: TFunction<[string], undefined>;
};

const getLabel = ({ formFieldSelectItems, value, t }: GetLabelProps) => {
  const rawLabel = formFieldSelectItems.find((el) => el.key === value)?.label;
  return rawLabel ? t(rawLabel) : 'Invalid value';
};

type SelectFromListFieldViewProps = {
  fieldKey: string;
  value?: ReactNode;
  formFieldSelectItems: Array<{
    key: string;
    label: string;
  }>;
  emptyText?: string;
  multiple?: boolean;
  isPdf?: boolean;
};

export const SelectFromListFieldView: FC<SelectFromListFieldViewProps> = ({
  fieldKey,
  value,
  formFieldSelectItems,
  emptyText = '-',
  multiple,
  isPdf,
}) => {
  const { t } = useTranslation([
    'contacts',
    'common',
    'forms_assets',
    'assets',
    'documents',
    'delegation',
  ]);

  if (!value) return emptyText;

  const isCountyField = getIsCountryField(fieldKey);

  if (multiple && Array.isArray(value)) {
    const labels = value.map((v) => getLabel({ value: v, formFieldSelectItems, t }));
    return labels.join(', ');
  }

  if (typeof value === 'string' && isCountyField && !isPdf) {
    return <Country code={value} />;
  }

  const label = getLabel({ value, formFieldSelectItems, t });
  return label;
};
